import React from "react";

function BookmarkSettingsTab(props) {
  return <div>Bookmarks (under construction...)</div>;
}

export default BookmarkSettingsTab;
